<app-uni-page
  [parent]="this"
  pageTitle="Add-On Bin Processor"
  [bodyTemplate]="bodyTemplate"
  [footerTemplate]="footerTemplate"
>
</app-uni-page>

<ng-template #bodyTemplate>
  <div class="flex flex-col h-full">
    <div *ngIf="addonBin" class="grid grid-cols-12 gap-4 px-4 pt-3 pb-2 shrink-0">
      <!-- Bin Info -->
      <div class="col-span-4 qb-detail-card qb-primary-tint p-4">
        <div class="font-semibold text-base mb-3 border-b pb-2 uppercase tracking-wide">Bin Info</div>
        <table class="qb-info-table">
          <tr>
            <td class="label">Bin Id</td>
            <td class="value">{{ addonBin.id }}</td>
          </tr>
          <tr>
            <td class="label">Account</td>
            <td class="value">{{ addonBin.account?.accountName }}</td>
          </tr>
          <tr>
            <td class="label">Status</td>
            <td class="value">{{ addonBin.addonBinStatus?.name }}</td>
          </tr>
          <tr *ngIf="addonBin.joHeaderId">
            <td class="label">Job Order</td>
            <td class="value">{{ addonBin.joHeaderId }}</td>
          </tr>
        </table>
      </div>

      <!-- Station Info -->
      <div class="col-span-4 qb-detail-card qb-primary-tint p-4">
        <div class="font-semibold text-base mb-3 border-b pb-2 uppercase tracking-wide">Station</div>
        <table class="qb-info-table">
          <tr>
            <td class="label">Current</td>
            <td class="value">{{ addonBin.currentAddonStation?.name || '—' }}</td>
          </tr>
          <tr>
            <td class="label">Status</td>
            <td class="value">{{ addonBin.currentAddonBinStationStatus?.name || '—' }}</td>
          </tr>
          <tr>
            <td class="label">Pending</td>
            <td class="value">
              <span *ngIf="!isBinComplete()">{{ addonBin.pendingAddonStation?.name || '—' }}</span>
              <span *ngIf="isBinComplete()" class="font-semibold">Next Step: Ship Prep</span>
            </td>
          </tr>
        </table>
      </div>

      <!-- Processing Info -->
      <div class="col-span-4 qb-detail-card qb-primary-tint p-4">
        <div class="font-semibold text-base mb-3 border-b pb-2 uppercase tracking-wide">Processing</div>
        <table class="qb-info-table">
          <tr>
            <td class="label">Priority</td>
            <td class="value">{{ addonBin.priorityOrder }}</td>
          </tr>
          <tr>
            <td class="label">Items in Bin</td>
            <td class="value">{{ binItemCount }}</td>
          </tr>
          <tr *ngIf="addonBin.pendingAddonStationId">
            <td class="label">Scanned</td>
            <td class="value">{{ pendingStationScannedCount }}</td>
          </tr>
          <tr *ngIf="addonBin.pendingAddonStationId">
            <td class="label">Remaining</td>
            <td class="value">{{ pendingStationRemainingCount }}</td>
          </tr>
        </table>
      </div>
    </div>

    <div class="flex justify-between items-center mr-4">
      <div class="flex items-center ml-4">
        <span class="mr-4">Item Details Requiring Addons</span>
        <p-checkbox
          [(ngModel)]="shouldShowAllItemDetailAddons"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="refreshGrid()"
          [binary]="true"
          inputId="shouldShowAllItemDetailAddons"
        >
        </p-checkbox>
        <label for="shouldShowAllItemDetailAddons" class="ml-2">Show all Add-On Stations</label>
      </div>
      <div class="flex items-center gap-2">
        <button
          *ngIf="canMarkStationInProcess()"
          pButton
          type="button"
          class="p-button-raised p-button-sm"
          (click)="markStation(AddonBinStationStatusEnum.InProcess)"
        >
          <span>Mark {{ addonBin.currentAddonStation.name }} station in process</span>
        </button>
        <button
          *ngIf="canMarkStationComplete()"
          pButton
          type="button"
          class="p-button-raised p-button-sm"
          (click)="markStation(AddonBinStationStatusEnum.Closed)"
        >
          <span>Mark {{ addonBin.currentAddonStation.name }} station complete</span>
        </button>
        <button
          *ngIf="canMarkStationOnHold()"
          pButton
          type="button"
          class="p-button-raised p-button-sm"
          (click)="markStation(AddonBinStationStatusEnum.OnHold)"
        >
          <span>Mark {{ addonBin.currentAddonStation.name }} station on hold</span>
        </button>
        <button
          *ngIf="canScanAll()"
          pButton
          type="button"
          class="p-button-raised p-button-sm"
          (click)="scanAll()"
        >
          <span>Scan All</span>
        </button>
        <button
          *ngIf="isBinComplete()"
          pButton
          type="button"
          class="p-button-raised p-button-sm"
          (click)="goShipPrep()"
        >
          <span>Go to Ship Prep</span>
        </button>
      </div>
    </div>

    <div class="h-full" style="min-height: 60px; margin-top: 6px;">
      <app-ag-grid
        [gridOptions]="detailGridOptions"
        [rowData]="itemDetailAddons"
      ></app-ag-grid>
    </div>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <p-progressSpinner
    *ngIf="isBusy()"
    ariaLabel="loading"
    [style]="{ width: '50px', height: '50px' }"
  />
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>
